export default {
  headerContent: {
    title: 'Türkiye Sigorta Tamamlayıcı Sağlık Sigortası Teklifi',
    slogan: "Tamamlayıcı Sağlık Sigortası'nı işin uzmanına bırak.",
    btnTitle: 'TAMAMLAYICI SAĞLIK SİGORTASI TEKLİFİ AL'
  },
  crossPageContent: {
    mainTitle: 'Türkiye Sigorta Tamamlayıcı Sağlık Sigortası',
    description: {
      title: 'Türkiye Sigorta Tamamlayıcı Sağlık Sigortası Nedir? ',
      content: [
        'Sağlık sigortası, sizi yüksek sağlık masraflarından korumaya yardımcı olur. Doktor ziyaretleri, hastanede kalışlar ve önemli koruyucu bakım masraflarını karşılamanıza yardımcı olur.',
        'Tamamlayıcı sağlık sigortası sosyal güvencesi bulunan bireylerin özel hastanelerde tedavi hizmeti almalarını sağlamaktadır. Hastalıklar ve yaralanmalar için çeşitli tedaviler için ödeme yapabilir.',
        '<strong>Türkiye Sigorta</strong> tamamlayıcı sağlık sigortası SGK ile anlaşmalı özel hastanelerde kaza veya hastalık sonucu alınması gereken tedavi hizmeti sonucunda oluşan maddi giderlere karşı koruma sunar.',
        'Ancak sağlık sigortası, yalnızca ihtiyacınız olan her şeyi kapsayan bir poliçe bulabilirseniz buna değer!'
      ]
    },
    subContent: {
      title: 'Türkiye Sigorta Tamamlayıcı Sağlık Sigortası Teminatları Nelerdir?',
      content: [
        {
          paragraph:
            'Tamamlayıcı sağlık sigortası teminatları yatarak, ayakta ve doğum olmak üzere 3’e ayrılmaktadır. ',
          subList: null
        },
        {
          paragraph:
            'Yatarak tedavi, hastanede 24 saati aşan yatış gerektiren tedavileri kapsamaktadır.',
          subList: null
        },
        {
          paragraph:
            '<strong><em><u>Yatarak Tedavi Teminatları;</u></em></strong>',
          subList: [
            'Ameliyat',
            'Hastanede tedavi',
            'Kemoterapi, Radyoterapi',
            'Oda / Yemek/ Refakatçi',
            'Acil ulaşım Ambulans',
            'Suni uzuv',
            'Tıbbi malzeme',
            'Evde Bakım'
          ]
        },
        {
          paragraph:
            'Ayakta tedavi, hastanede 24 saati aşmayan yatış gerektirmeyen tedavileri kapsamaktadır.',
          subList: null
        },
        {
          paragraph:
            '<strong><em><u>Ayakta Tedavi Teminatları;</u></em></strong>',
          subList: [
            'Doktor Muayene',
            'Laboratuvar',
            'Görüntüleme',
            'Modern Teşhis ( MR, Tomografi vb.)',
            'Fizik Tedavi'
          ]
        }
      ]
    }
  },
  getPrice: {
    mainTitle: 'Tamamlayıcı Sağlık Sigortası Teklifi Nasıl Alınır?',
    campaigns: [
      {
        id: 1,
        name: 'Tamamlayıcı Sağlık Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      },
      {
        id: 2,
        name: 'Tamamlayıcı Sağlık Sigortası',
        assurance: 'Standart Teminatlı',
        price: '+50 TL'
      },
      {
        id: 3,
        name: 'Tamamlayıcı Sağlık Sigortası',
        assurance: 'Zorunlu Teminatlı',
        price: '+50 TL'
      },
      {
        id: 4,
        name: 'Tamamlayıcı Sağlık Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      }
    ]
  },
  faqTitle: 'Türkiye Sigorta Tamamlayıcı Sağlık Sigortası Hakkında Merak Edilenler',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: [
    {
      title:
        'Türkiye Sigorta Tamamlayıcı Sağlık Sigortası Teminat Dışı Kalan Haller Nelerdir?',
      content: [
        {
          paragraph: null,
          subList: [
            'Acil durumlar da dâhil olmak üzere anlaşmasız kurumlarda yapılacak tedavilere ilişkin giderler teminat kapsamında değerlendirilmez.',
            'İlaç ve aşı giderleri poliçe teminat kapsamı dışındadır.',
            'Sosyal Güvenlik Kurumu’nca karşılanmayan sağlık hizmetleri teminat kapsamında değerlendirilmez.',
            'Yatarak tedavi giderleri, rahatsızlığın ani veya kaza sonucu olarak ortaya çıkmasına bakılmaksızın sigorta başlangıç tarihinden itibaren 90 gün süre ile kapsam dışındadır. Ayakta ve yatarak olmasına bakılmaksızın fizik tedavi ve rehabilitasyon, endoskopik girişimler 90 gün süre ile kapsam dışındadır.',
            'Tamamlayıcı sağlık sigortası poliçesinin başlangıç tarihinden önceye dayanan rahatsızlıklar ödenmez.'
          ]
        }
      ]
    },
    {
      title:
        'Türkiye Sigorta Tamamlayıcı Sağlık Sigortası Neleri Kapsar?',
      content: [
        {
          paragraph:
            'Tamamlayıcı sağlık sigortası kapsamı poliçeye eklenen teminatlara göre belirlenmektedir. Poliçede yer alan teminatları poliçe süresi içerisinde kullanabilirsiniz. Poliçeniz başlangıç tarihinden itibaren 1 yıl geçerlidir.',
          subList: null
        }
      ]
    },
    {
      title:
        'Türkiye Sigorta Tamamlayıcı Sağlık Sigortasından Kimler Yararlanabilir?',
      content: [
        {
          paragraph:
            'Tamamlayıcı sağlık sigortasından sosyal güvencesi olan ve 0 – 60 yaş arası olan tüm kişiler yararlanabilir.',
          subList: null
        }
      ]
    },
    {
      title:
        'Türkiye Sigorta Tamamlayıcı Sağlık Sigortası Yaş Sınırı Nedir?',
      content: [
        {
          paragraph:
            'Türkiye Sigorta tamamlayıcı sağlık sigortası 0 yaştan 60 yaşa kadar tüm kişiler yapılmaktadır.',
          subList: null
        }
      ]
    },
    {
      title:
        'Türkiye Sigorta Tamamlayıcı Sağlık Sigortası Hangi Hastanelerde Geçerli?',
      content: [
        {
          paragraph:
            'Tamamlayıcı sağlık sigortası Türkiye Sigorta ile anlaşmalı özel hastanelerde ve polikliniklerde geçerlidir.',
          subList: null
        }
      ]
    },
    {
      title:
        'Türkiye Sigorta Aile Tamamlayıcı Sağlık Sigortası Nedir?',
      content: [
        {
          paragraph:
            'Aile tamamlayıcı sağlık sigortası, aile fertlerinin basına gelebilecek hastalık veya kaza sonucunda alınması gereken tedavi hizmetleri sonucu oluşacak masrafları güvence altına almaktadır. Standart tamamlayıcı sağlık sigortasına göre primi daha uygundur. Bunun sebebi ise aile indirimi bulunmasındandır.',
          subList: null
        }
      ]
    },
    {
      title:
        'Türkiye Sigorta Aile Tamamlayıcı Sağlık Sigortası İndirim Oranı Nedir?',
      content: [
        {
          paragraph:
            'Poliçe kapsamında 2 veya daha fazla birey olması durumunda %10 indirim kazanılmaktadır.',
          subList: null
        }
      ]
    },
    {
      title:
        'Türkiye Sigorta Tamamlayıcı Sağlık Sigortası Ne Zaman Başlar?',
      content: [
        {
          paragraph:
            'Tamamlayıcı sağlık sigortası sigorta sözleşmesinin düzenlenmesi, belirli bir ödemenin yapılmasından sonra başlamaktadır.',
          subList: null
        }
      ]
    },
    {
      title:
        'Türkiye Sigorta Tamamlayıcı Sağlık Sigortası Poliçe Süresi Ne Kadardır?',
      content: [
        {
          paragraph:
            'Tamamlayıcı sağlık sigortası geçerlilik süresi 1 yıldır. Poliçede yazan başlangıç tarihinden 1 yıl sonra sona ermektedir.',
          subList: null
        }
      ]
    },
    {
      title:
        'Türkiye Sigorta Tamamlayıcı Sağlık Sigortası Bekleme Süresi Nedir?',
      content: [
        {
          paragraph:
            'Tamamlayıcı sağlık sigortası içerisinde bulunan bekleme süresi SGK tarafından uygulanan bekleme süresidir. Bunun dışında bekleme süresi bulunamamaktadır.',
          subList: null
        }
      ]
    },
    {
      title:
        'Türkiye Sigorta Tamamlayıcı Sağlık Sigortasında İlaç Masrafları Poliçe Kapsamında Ödenir Mi?',
      content: [
        {
          paragraph:
            'Tamamlayıcı sağlık sigortası kapsamında ilaç ücretleri karşılanmamaktadır.',
          subList: null
        }
      ]
    },
    {
      title:
        'Türkiye Sigorta Tamamlayıcı Sağlık Sigortası Diyetisyeni Karşılar Mı?',
      content: [
        {
          paragraph:
            'Diyetisyen hizmeti Türkiye Sigorta tamamlayıcı sağlık sigortası kapsamında karşılanmamaktadır.',
          subList: null
        }
      ]
    },
    {
      title:
        'Türkiye Sigorta Tamamlayıcı Sağlık Sigortası Göz Tedavisini Karşılar Mı?',
      content: [
        {
          paragraph:
            'Türkiye Sigorta göz muayeneleri, poliçe öncesi bulunmayan ve SGK tarafından onaylı göz ameliyatlarını karşılanmaktadır.',
          subList: null
        }
      ]
    },
    {
      title:
        'Türkiye Sigorta Tamamlayıcı Sağlık Sigortası Gözlüğü Karşılar Mı?',
      content: [
        {
          paragraph:
            'Tamamlayıcı sağlık sigortası kapsamında gözlük karşılanmamaktadır.',
          subList: null
        }
      ]
    },
    {
      title:
        'Türkiye Sigorta Tamamlayıcı Sağlık Sigortası Poliçem Yurt Dışında Geçerli Mi?',
      content: [
        {
          paragraph:
            'Tamamlayıcı sağlık sigortası sadece Türkiye Sınırları içerisinde geçerlidir. Yurt dışında tamamlayıcı sağlık sigortası kullanılamamaktadır.',
          subList: null
        }
      ]
    },
    {
      title:
        'Resmi Tatil ve Pazar Günü Tamamlayıcı Sağlık Sigortamı Kullanabilir Miyim?',
      content: [
        {
          paragraph:
            'Tamamlayıcı sağlık sigortasında gün ve saat kısıtlaması bulunamamaktadır. Poliçenizi 7/24 kullanabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title:
        'Türkiye Sigorta Tamamlayıcı Sağlık Sigortası Geçmişten Gelen Hastalıkları Öder Mi?',
      content: [
        {
          paragraph:
            'Tüm sağlık sigortalarında olduğu gibi tamamlayıcı sağlık sigortasında da geçmiş dönemden gelen hastalıklar karşılanmamaktadır.',
          subList: null
        }
      ]
    },
    {
      title:
        'Türkiye Sigorta Tamamlayıcı Sağlık Sigortası Doğum Paketi Nedir?',
      content: [
        {
          paragraph:
            'Doğum paketi, sigortalının hamilelik döneminde gerekli olan rutin kontroller ve doğum anını sigorta güvencesine almaktadır. Doğum teminatına sahip olan sigortalının doğuma ait olan giderleri poliçede belirtilmiş olan limitler dâhilinde şirket tarafından karşılanmaktadır.',
          subList: [
            'Yatarak ve Yatarak + Ayakta Tedavi planlarıyla birlikte Doğum Teminatı isteğe bağlı olarak poliçe kapsamına eklenebilir.',
            'Yatarak Tedavi planında sadece doğum eylemi geçerli olmaktadır. Bu kapsamda Doğum Teminatı için bekleme süresi 1 yıldır.'
          ]
        }
      ]
    },
    {
      title:
        'Türkiye Sigorta Tamamlayıcı Sağlık Sigortası Tüp Bebeği Karşılar Mı?',
      content: [
        {
          paragraph:
            'Tamamlayıcı sağlık sigortası kapsamında tüp bebek karşılanmamaktadır.',
          subList: null
        }
      ]
    },
    {
      title:
        'Türkiye Sigorta Tamamlayıcı Sağlık Sigortası Sünneti Karşılar Mı?',
      content: [
        {
          paragraph:
            'Tamamlayıcı sağlık sigortası kapsamında sünnet teminatı verilmemektedir.',
          subList: null
        }
      ]
    },
    {
      title:
        'Türkiye Sigorta Tamamlayıcı Sağlık Sigortası Mr Karşılar Mı?',
      content: [
        {
          paragraph:
            'MR doktor muayenesi sonucunda istenmesi durumunda tamamlayıcı sağlık sigortası kapsamında karşılanmaktadır. Yalnız doktor tarafından istenmeyen MR poliçe kapsamında karşılanmamaktadır.',
          subList: null
        }
      ]
    },
    {
      title:
        'Türkiye Sigorta Tamamlayıcı Sağlık Sigortası Burun Ameliyatını Karşılar Mı?',
      content: [
        {
          paragraph:
            'Estetik olarak yapılan burun ameliyatları tamamlayıcı sağlık sigortası tarafından karşılanmamaktadır.',
          subList: null
        }
      ]
    },
    {
      title:
        'Türkiye Sigorta Tamamlayıcı Sağlık Sigortası Hesaplama Nasıl Yapılır?',
      content: [
        {
          paragraph:
            'Tamamlayıcı sağlık sigortası hesaplaması başvuru formunda yer alan soruların doldurulması ile gerçekleşmektedir.',
          subList: null
        },
        {
          paragraph:
            'Başvuru formuna bilgiler doğru, eksiksiz ve kesin olarak girilmelidir.',
          subList: null
        }
      ]
    },
    {
      title:
        'Türkiye Sigorta Tamamlayıcı Sağlık Sigortası Vergi İndirimi Nasıl Kullanılır?',
      content: [
        {
          paragraph:
            'Satın almış olunan tamamlayıcı sağlık sigortasının bir nüshasını muhasebeye ileterek vergi indirimi sağlanabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title:
        'Türkiye Sigorta Tamamlayıcı Sağlık Sigortası Nasıl Kullanılır?',
      content: [
        {
          paragraph:
            'Tamamlayıcı sağlık sigortanızı ayakta tedavilerinizi satın aldıktan sonra kullanmaya başlayabilirsiniz. Yalnız doğum ve yatarak tedavileriniz için bulunan bekleme sürelerinin dolması gerekmektedir. Bekleme sürelerinin dolmasından sonra yatarak tedavileriniz ve doğum için kullanabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title:
        'Tamamlayıcı Sağlık Sigortası Sorgulama Nasıl Yapılır?',
      content: [
        {
          paragraph:
            'Tamamlayıcı sağlık sigortası 3 farklı yöntemle yapılabilmektedir. Bu yöntemler;',
          subList: [
            'Merkez ofisimizi ziyaret ederek',
            '7/24 hizmet veren çağrı merkezimizi kullanarak',
            'Alokasko.com üzerinden tamamlayıcı sağlık sigortası sorgulaması yapabilirsiniz.'
          ]
        }
      ]
    },
    {
      title:
        'İnternetten Tamamlayıcı Sağlık Sigortası Teklifi Nasıl Alınır?',
      content: [
        {
          paragraph:
            'Bir hastalık veya yaralanma için özel tedavi istiyorsanız, doğru sağlık sigortası poliçesi paradan tasarruf etmenizi sağlayabilir. İhtiyacınız olan her şeyi kapsayan sağlık sigortası planını tercih ettiğinizden emin olmalısınız.',
          subList: null
        },
        {
          paragraph:
            'İnternetten online sağlık sigortası fiyatı alarak en doğru poliçeye uzmanlarımız doğrultusunda ulaşabilirsiniz. Online teklif almak için başvuru formumuzu doldurmanız yeterlidir.',
          subList: null
        }
      ]
    },
    {
      title:
        'Türkiye Sigorta Tamamlayıcı Sağlık Sigortası Fiyatları Ne Kadar?',
      content: [
        {
          paragraph:
            'Tamamlayıcı sağlık sigortası kişiye özel olarak düzenlenmektedir. Bundan dolayı fiyatlar kişiden kişiye göre değişmektedir. Tamamlayıcı sağlık sigortası fiyatları kişinin yaşı, geçmiş dönem rahatsızlıkları, bulunduğu ile ve cinsiyetine göre değişmektedir.',
          subList: null
        },
        {
          paragraph:
            'Sizin için en uygun tamamlayıcı sağlık sigortası için Alokasko.com üzerinde başvuru formu doldurabilir veya 7/24 hizmet veren çağrı merkezimizden hizmet alabilirsiniz.',
          subList: null
        },
        {
          paragraph:
            'İhtiyaç duyabileceğinizi düşündüğünüz tüm tedavileri kapsayan en ucuz politikayı seçerek paradan tasarruf edebilirsiniz. Hemen teklif al formunu doldurabilir ve Türkiye Sigorta fiyatlarını değerlendirmeye başlayabilirsiniz.',
          subList: null
        }
      ]
    }
  ]
}
